"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.resolveBillingPeriod = void 0;
const legacy_enums_1 = require("@daytrip/legacy-enums");
const date_fns_1 = require("date-fns");
function resolveBillingPeriod(dateWithinPeriod, firstPeriodStart, periodUnit, periodLength) {
    if (dateWithinPeriod < firstPeriodStart) {
        throw new Error("Can't resolve for a date before first billing period");
    }
    if (periodLength < 1) {
        throw new Error("Can't resolve for period length below 1");
    }
    if (periodUnit === legacy_enums_1.CreditLinePeriodUnit.Month && periodLength === 1) {
        const start = new Date(dateWithinPeriod.getUTCFullYear(), dateWithinPeriod.getUTCMonth(), 1);
        const end = calculateBillingPeriodEnd(start, periodUnit, periodLength);
        return {
            start,
            end,
        };
    }
    if (periodUnit === legacy_enums_1.CreditLinePeriodUnit.Week && periodLength === 1) {
        // days are indexed from Sunday = 0 but we need Monday = 1 as start of billing period (0-6=-6 to change Sunday to Monday)
        const dayDistance = (-6 - dateWithinPeriod.getUTCDay()) % 7;
        const dateWithinPeriodWithoutHours = new Date(dateWithinPeriod.getUTCFullYear(), dateWithinPeriod.getUTCMonth(), dateWithinPeriod.getUTCDate());
        const start = (0, date_fns_1.addDays)(dateWithinPeriodWithoutHours, dayDistance);
        const end = calculateBillingPeriodEnd(start, periodUnit, periodLength);
        return {
            start,
            end,
        };
    }
    // for period length > 1 we need to iterate from the start of first billing period to determine current billing period
    let possibleStart = new Date(firstPeriodStart);
    let possibleEnd = calculateBillingPeriodEnd(possibleStart, periodUnit, periodLength);
    while (possibleEnd < dateWithinPeriod) {
        possibleStart = new Date(possibleEnd.getTime() + 1); // adding one millisecond to get to next day
        possibleEnd = calculateBillingPeriodEnd(possibleStart, periodUnit, periodLength);
    }
    return {
        start: possibleStart,
        end: possibleEnd,
    };
}
exports.resolveBillingPeriod = resolveBillingPeriod;
function calculateBillingPeriodEnd(startDate, periodUnit, periodLength) {
    const year = startDate.getFullYear();
    const month = startDate.getMonth();
    const day = startDate.getDate();
    switch (periodUnit) {
        case legacy_enums_1.CreditLinePeriodUnit.Week:
            return (0, date_fns_1.addDays)(new Date(year, month, day, 23, 59, 59, 999), 7 * periodLength - 1);
        case legacy_enums_1.CreditLinePeriodUnit.Month:
            // using 0 as date will result in last day of previous month
            return new Date(year, month + periodLength, 0, 23, 59, 59, 999);
        default:
            throw new Error(`Unsupported credit line period unit ${periodLength}`);
    }
}
//# sourceMappingURL=resolveBillingPeriod.js.map